module.exports = __webpack_public_path__ + "static/media/nicolas_otamendi.7bce96eb.jpg";